import * as React from "react";
const SvgUnchecked = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, fill: "white", stroke: "#6EC5C5" }));
export default SvgUnchecked;
